<template>
	<div>
		<Card>
			<template slot="header">
				<h5 v-if="$slots.title || title" class="card-title">
					<slot name="title">
						{{title}}
					</slot>
				</h5>
			</template>
			<div class="row">
				<div class="col-xl-12 loading-spinner" v-if="isLoading">
					<vue-loaders-line-spin-fade-loader class="loading" color="white" scale="1.4"/>
				</div>
				<div class="col-xl-12 pb-4" v-else>
					<div class="row">
						<div class="col-xl-12 text-center">
							<button type="button" class="filter-action" @click="openCalendar=true">Show Calendar</button>
						</div>
					</div>
					<div class="row">
						<div class="col-xl-3 col-sm-3 col-xs-6 gauge-panel"
								 v-for="(item, index) in sensorTempData"
								 :key="index">
							<temperature-guage :name="item.name" :value="item.value"></temperature-guage>
						</div>
					</div>
					<div class="row pb-5 pt-5">
						<div class="col-xl-12">
							<range-selector></range-selector>
						</div>
					</div>
					<div class="row pb-5 pt-5 text-center">
						<div class="col-xl-12">
							<button type="button" class="filter-action" @click="applyTemp">Apply</button>
						</div>
					</div>
				</div>
			</div>
		</Card>
		<vue-modaltor :visible="openCalendar" :close-scroll="true">
			<template #header>
				<div>
					<i class="close-icon" @click="openCalendar=false">x</i>
				</div>
			</template>
			<template #body>
				<div class="container">
					<div class="row">
						<div class="col-xl-12">
							<event-calendar></event-calendar>
						</div>
					</div>
				</div>
			</template>
		</vue-modaltor>
	</div>

</template>
<script>

import { mapActions, mapGetters } from "vuex";
import QuerySetting from '@/mixins/querySetting';
import {
	TemperatureGuage,
	EventCalendar,
	RangeSelector
} from '@/components/index';
import Card from "@/components/Cards/Card.vue";

export default {
	name: "hvac-control-card",
	mixins: [QuerySetting],
	props: {
		title: {
			type: String,
			default: ''
		}
	},
	components: {
		RangeSelector,
		TemperatureGuage,
		EventCalendar,
		Card
	},
	computed: {
		...mapGetters({
			periodTime: 'settime/getPeriodTime',
			defaultSiteId: 'auth/getDefaultSiteId'
		})
	},
	data() {
		return {
			isLoading: false,
			selectedItem: null,
			sensorTempData: [],
			openCalendar: false,
			value: 4.56
		}
	},
	watch: {
		async periodTime(newValue) {
			this.sensorTempData = [];
			await this.getTemperatureData(this.periodTime, 'temperature');
		},
		value: {
			handler: function (newValue) {
				this.changeTemperature(newValue);
			},
			immediate: true
		},
		async defaultSiteId(newValue) {
			this.sensorTempData = [];
			await this.getTemperatureData(this.periodTime, 'temperature');
		}
	},
	async mounted() {
		this.sensorTempData = [];
		await this.getTemperatureData(this.periodTime, 'temperature');
	},
	methods: {
		...mapActions({
			getData: 'influx/getInfluxData'
		}),
		async getTemperatureData(value, type) {
			// this.isLoading = true;
			const query = this.getHvacQuery(value, type);
			for (let i = 0; i < query.length; i++) {
				const envData = await this.getData(query[i].query);
				this.sensorTempData.push({
					name: query[i].name,
					value: Math.round((envData[0]._value + Number.EPSILON) * 100) / 100});
			}
			this.isLoading = false;
		},
		changeTemperature() {
			if (this.selectedItem) {
				this.selectedItem.value = this.value
			}
		},
		applyTemp() {
			console.log("test");
		}
	},
};
</script>
<style lang="scss" scoped>
.loading-spinner {
	margin: 0 auto;
}
#slider-input {
	width: 80%;
}
.gauge-panel {
	cursor: pointer;
}
.close-icon {
	position: relative;
	top: 6px;
	left: 98%;
	cursor: pointer;
	font-size: 20px;
}
.filter-action {
	width: 180px;
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 4px;
	z-index: 8;
	&:hover, &.active {
		background-color: #1f5881;
	}
}
</style>
